// Lib
import React, { ReactElement } from 'react';

// Utils
import { getLinkUrl } from '../../../common/elements/utils/elementPropertyUtils';

// Components
import LinkInput from './LinkInput';
import LinkStateDisplay from './LinkStateDisplay';

// Styles
import './LinkEditor.scss';

// Types
import { ImMNElement } from '../../../common/elements/elementModelTypes';
import { ImElementLocalData } from '../local/elementLocalDataTypes';
import { AttachmentState } from '../attachments/attachmentTypes';

type ValidationResponse = unknown; // TODO: use fieldValidationService's return type once it has one

export type LinkEditorProps = {
    element: ImMNElement;
    elementLocalData: ImElementLocalData;
    attachment: AttachmentState;

    isSelected: boolean;
    isEditing: boolean;
    isSingleSelected: boolean;

    setLinkUrl: (url: string) => ValidationResponse | null;
    setLocalData: (data: any) => void;
    startEditing: (data: any) => void;
    stopEditing: () => void;
    moveElementsToTrash: () => void;
    deselectAll: () => void;
};

const LinkEditor = (props: LinkEditorProps): ReactElement | null => {
    const isLoaded = getLinkUrl(props.element);

    if (isLoaded) return null;

    return (
        <div className="LinkEditor">
            <LinkStateDisplay {...props} />
            <LinkInput {...props} />
        </div>
    );
};

export default LinkEditor;
